module.exports = __webpack_public_path__ + "media/post-listing-cta-background.119f3bba.jpg";